import React, { Component } from "react"
import { connect } from "react-redux"
import Title from "../../common/Title"
import InputField from "../../common/InputField"
import { Button } from "../../common/Button"
import Loader from "../../common/Loader"
import { isValidField } from "../../../utils/FieldsValidation"
import Message from "../../common/Message"
import {
  onUserSignInRequest,
  onUserSignInClick,
  onUserSignOut,
  closeMessage,
} from "../../../actions"

import "./style.scss"

class LoginScreen extends Component {
  constructor(props) {
    super(props)
    this.INIT_STATE = {
      name: "",
      passw: "",
      validField: {
        passw: {
          type: "text",
          isRequired: true,
          isChecked: false,
          isValid: false,
        },
      },
    }

    this.state = this.INIT_STATE
  }

  componentDidMount() {
    const { authenticated } = this.props
    if (authenticated) {
      this.props.onUserSignOut()
    }
    this.state = this.INIT_STATE
  }

  componentDidUpdate() {
    const { authenticated } = this.props
    authenticated && this.props.history.push("OrderByCodeScreen")
  }

  componentWillUnmount() {
    this.state = this.INIT_STATE
  }

  setValue(inputName, e) {
    switch (inputName) {
      case "name":
        this.setState({ name: e.target.value })
        break
      case "passw":
        this.setState({ passw: e.target.value })
        break
      default:
        break
    }
  }

  onInputFocus(inputName) {
    let { validField } = this.state
    let field = validField[inputName]
    if (!field) return

    field.isChecked = false
    field.isValid = false
    validField[inputName] = field

    this.setState({
      ...this.state,
      validField,
    })
  }

  validateInputValue(inputName, value) {
    let { validField } = this.state
    let field = validField[inputName]
    if (!field) return

    field.isChecked = true
    field.isValid = isValidField(
      value,
      field.type,
      field.isRequired,
      field.compareMinValue,
      field.compareMaxValue
    )
    validField[inputName] = field

    this.setState({
      ...this.state,
      validField,
    })
  }

  onClickLoginButton() {
    const { validField, name, passw } = this.state
    this.validateInputValue("passw", passw)
    const isValid = validField.passw.isChecked && validField.passw.isValid
    if (!isValid) {
      return
    }
    this.props.onUserSignInRequest()
    this.props.onUserSignInClick(name, passw)
  }

  onMessageClickOk(e) {
    this.props.closeMessage()
  }

  render() {
    const { validField } = this.state
    const { isLoading, showMessage } = this.props

    if (isLoading) {
      return (
        <div>
          <Title text="כניסה למערכת" />
          <Loader show={isLoading} />
        </div>
      )
    }
    return (
      <div className="login">
        <Title text="כניסה למערכת" />
        <form>
          <InputField
            isFocused={true}
            show={true}
            value={this.state.name}
            placeholder="מספר טלפון"
            mandatory={true}
            onChange={(e) => this.setValue("name", e)}
          />
          <InputField
            show={true}
            value={this.state.passw}
            iconStyle=""
            placeholder="סיסמא"
            mandatory={true}
            cc={validField.passw.isChecked}
            showValidationOk={validField.passw.isValid}
            showValidationError={!validField.passw.isValid}
            validationErrorMessage="סיסמא לא תקינה"
            onFocus={(e) => this.onInputFocus("passw")}
            onBlur={(e) => this.validateInputValue("passw", e.target.value)}
            onChange={(e) => this.setValue("passw", e)}
            type="password"
            maxLength={20}
          />
          <div className="button-wrapper">
            <Button onClick={(e) => this.onClickLoginButton()}>כניסה</Button>
          </div>
          <Message
            show={showMessage}
            isError={true}
            successText=""
            errorText="אנא בדוק את הפרטים ונסה שוב"
            onClick={(e) => this.onMessageClickOk(e)}
          />
        </form>
      </div>
    )
  }
}

const mapStateToProps = ({ users }) => {
  const { authenticated, userData, isLoading, showMessage } = users

  return {
    authenticated,
    userData,
    isLoading,
    showMessage,
  }
}

export default connect(mapStateToProps, {
  onUserSignInRequest,
  onUserSignInClick,
  onUserSignOut,
  closeMessage,
})(LoginScreen)
